import useSettingNoti from "../hooks/useSettingNoti";
import LayoutSetting from "./LayoutSetting";

function SettingNotiEmil() {
  const settingNoti = useSettingNoti();
  return (
    <LayoutSetting {...settingNoti} />
  );
}

export default SettingNotiEmil;
